import { render, staticRenderFns } from "./DetailsLayout.vue?vue&type=template&id=59e68ad0&"
import script from "./DetailsLayout.vue?vue&type=script&lang=js&"
export * from "./DetailsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports